import { useState, useCallback, useContext } from 'react'
import { AuthContext } from '../context/AuthContext'
import { LanguagesContext } from '../context/LanguagesContext'

export const useHttp = () => {
  const auth = useContext(AuthContext)
  const { pageLanguage } = useContext(LanguagesContext);
  const [loading, setLoading] = useState(false)
  const [progress, setProgress] = useState(false)
  const [error, setError] = useState(null)
  // const [cancelUpload, setCancelUpload] = useState(false)
  const [cancelUpload, setCancelUpload] = useState(false)

  const request = useCallback(async (url, method = 'GET', body = null, headers = {}, isFile = false) => {
    setLoading(true)
    try {
      headers['Accept-Language'] = pageLanguage;

      if (body) {
        if (headers['Content-Type'] === undefined) {
          headers['Content-Type'] = 'application/json'
          body = JSON.stringify(body)
        }
        else if (headers['Content-Type'] === 'multipart/form-data') {
          delete headers['Content-Type'] // the way to fix browser error https://stackoverflow.com/questions/39280438/fetch-missing-boundary-in-multipart-form-data-post
        }

        // body = JSON.stringify(body)
        // headers['Content-Type'] = 'application/json'
        // headers['Content-Type'] ='application/x-www-form-urlencoded'; <-form_Data
      }

      //fetch has no upload progress, to get file progress we use XHR
      if (!isFile) {
        const response = await fetch(process.env.REACT_APP_API + url, { method, body, headers })
        const data = await response.json()
        setLoading(false);

        if (response.status === 401) {
          auth.logout()
        }

        if (response.status !== 200 && response.status !== 201) {
          console.log('Http Error:', `${response.status} | ${response.type} | ${response.statusText}`);
          throw data
        }

        return data
      } else {
        const xhr = new XMLHttpRequest();
        method = 'POST';

        return new Promise(function (resolve, reject) {

          xhr.upload.onprogress = function (event) {
            // console.log(event.loaded + ' / ' + event.total);
            setProgress({ total: event.total, progress: event.loaded })
            if (cancelUpload === true) {
              xhr.abort()
              setCancelUpload(false);
              throw reject({
                message: 'Upload cancelled'
              });
            }
          }

          xhr.onload = xhr.onerror = function () {
            if (this.status !== 200 && this.status !== 201) {

              throw reject({
                message: xhr.response ? xhr.response.message : "XMLHttpRequest error",
                status: this.status
              });
            } else {
              resolve(xhr.response)
            }
          };

          xhr.responseType = 'json';
          xhr.open(method, process.env.REACT_APP_API + url, true);
          xhr.setRequestHeader('x-access-token', headers['x-access-token']);
          //browser will add bounday automatically
          //xhr.setRequestHeader('Content-Type', `${headers['Content-Type']}; boundary='---${String(Math.random()).slice(2)}'`);
          xhr.send(body);

        }).then(function (data) {
          setProgress(false)
          setLoading(false);
          return data;

        }).catch(function (e) {
          setProgress(false)
          setLoading(false)
          throw e;
        });
      }

    } catch (e) {
      setError(e.message)
      setLoading(false);
      throw e
    }
  }, [auth, cancelUpload])

  const clearError = useCallback(() => setError(null), [])
  const abortUpload = useCallback(() => {
    setCancelUpload(false);
    // setCancelUpload(true)
  }, [])

  return { loading, request, error, clearError, progress, abortUpload }
}
